import { Auth } from 'aws-amplify';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IS_EMBEDDED_SESSION_KEY } from '../../typings/auth-message';

interface RequireAuthProps {
  children: React.ReactNode;
}

const RequireAuth = ({ children }: RequireAuthProps) => {
  const navigate = useNavigate();
  const isEmbedded = sessionStorage.getItem(IS_EMBEDDED_SESSION_KEY) === 'true';

  useEffect(() => {
    if (isEmbedded) {
      return;
    }

    const checkAuthStatus = async () => {
      try {
        await Auth.currentAuthenticatedUser();
      } catch {
        // If user is not authenticated, redirect to the login page
        navigate('/login');
      }
    };

    checkAuthStatus();
  }, [navigate, isEmbedded]);

  return <>{children}</>;
};

export { RequireAuth };
